import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dot-flash-animation',
    templateUrl: './dot-flash-animation.component.html',
    styleUrls: ['./dot-flash-animation.component.scss'],
    standalone: true,
})
export class DotFlashAnimationComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
